// @ts-nocheck

import Formatter from '../../../i18n/formatter';
import { __, getCurrency } from '../../../i18n/l10n';
import { basketErrors } from '../constants';

export default ({ ecode, einfo, estr, am, bsid }) => {
  let message = null;
  switch (ecode) {
    case 0: {
      if (am !== undefined && am !== '') {
        message = am;
      } else if (bsid !== undefined && bsid !== '') {
        const hyphenPosition = bsid.indexOf('-');
        bsid = bsid.slice(hyphenPosition + 1, bsid.length + 1);
        message = `${__('Bet validated')} - ${bsid}`;
      }
      break;
    }
    case basketErrors.ERROR_CODE_ACCESS_DENIED: {
      message = __('You must be logged in to validate your bets');
      break;
    }
    case basketErrors.ERROR_CODE_BAD_REQUEST: {
      message = __('Internal error');
      break;
    }
    case basketErrors.ERROR_CODE_MAINTENANCE: {
      message = __('Maintenance in progress');
      break;
    }
    case basketErrors.ERROR_CODE_SAME_BET: {
      message = __('You have already placed the same bet recently');
      break;
    }
    case basketErrors.ERROR_CODE_DB_ERROR: {
      message = __('Internal error');
      break;
    }
    case basketErrors.ERROR_CODE_NOT_ENOUGH_MONEY: {
      if (einfo !== undefined && einfo.max !== undefined) {
        const amount = parseFloat(einfo.max / 100);
        message = __('You only have %1$s', Formatter.formatNumber(amount, getCurrency()));
      }
      break;
    }
    case basketErrors.ERROR_CODE_ACCOUNT_LOCKED: {
      message = __('Your account is locked');
      break;
    }
    case basketErrors.ERROR_CODE_ODDS_UNDER_LIMIT: {
      if (einfo !== undefined && einfo.min !== undefined) {
        if (!isNaN(einfo.min)) {
          const odd = parseFloat(einfo.min / 1000);
          message = __('The minimum odds are %1$s', Formatter.formatNumber(odd));
        }
      }
      break;
    }
    case basketErrors.ERROR_CODE_AMOUNT: {
      message = __('Incorrect amount');
      break;
    }
    case basketErrors.ERROR_CODE_AMOUNT_UNDER_LIMIT: {
      if (einfo !== undefined && einfo.min !== undefined) {
        if (!isNaN(einfo.min)) {
          const amount = parseFloat(einfo.min / 100);
          message = __('The minimum wager is %1$s', Formatter.formatNumber(amount, getCurrency()));
        }
      }
      break;
    }
    case basketErrors.ERROR_CODE_AMOUNT_OVER_LIMIT: {
      if (einfo !== undefined && einfo.max !== undefined) {
        if (!isNaN(einfo.max)) {
          const amount = parseFloat(einfo.max / 100);
          message = __('The maximum wager is %1$s', Formatter.formatNumber(amount, getCurrency()));
        }
      }
      break;
    }
    case basketErrors.ERROR_CODE_DAILY_MODERATOR_REACHED:
    case basketErrors.ERROR_CODE_WEEKLY_MODERATOR_REACHED:
    case basketErrors.ERROR_CODE_MONTHLY_MODERATOR_REACHED: {
      if (einfo !== undefined && einfo.max !== undefined) {
        if (!isNaN(einfo.max)) {
          const amount = parseFloat(einfo.max / 100);
          const amountLabel = Formatter.formatNumber(amount, getCurrency());
          if (ecode === basketErrors.ERROR_CODE_DAILY_MODERATOR_REACHED) {
            message = __('You will exceed your daily limit. The maximum wager is %1$s', amountLabel);
          } else if (ecode === basketErrors.ERROR_CODE_WEEKLY_MODERATOR_REACHED) {
            message = __('You will exceed your weekly limit. The maximum wager is %1$s', amountLabel);
          } else if (ecode === basketErrors.ERROR_CODE_MONTHLY_MODERATOR_REACHED) {
            message = __('You will exceed your monthly limit. The maximum wager is %1$s', amountLabel);
          }
        }
      }
      break;
    }
    case basketErrors.ERROR_CODE_ODDS_CHANGED: {
      message = __('The odds have changed');
      break;
    }
    case basketErrors.ERROR_CODE_BET_SUSPENDED:
    case basketErrors.ERROR_CODE_BETSLIP_DETAIL_BET_SUSPENDED: {
      message = __('Bet suspended');
      break;
    }
    case basketErrors.ERROR_CODE_BET_STOPPED:
    case basketErrors.ERROR_CODE_BETSLIP_DETAIL_BET_STOPPED: {
      message = __('Bet stopped');
      break;
    }
    case basketErrors.ERROR_CODE_TRADER: {
      message = __('Bet pending');
      break;
    }
    case basketErrors.ERROR_CODE_BET_MODIFICATION_UNAVAILABLE: {
      message = __('Bet modification unavailable');
      break;
    }
    case basketErrors.ERROR_CODE_BET_MODIFICATION_UNAVAILABLE_WITH_FREE_BETS: {
      message = __('Bet modification unavailable with free bets');
      break;
    }
    default:
      message = estr || null;
      break;
  }
  return message;
};
